import { useEffect } from "react";
import { useParams } from "react-router";
import type { ScreenDef } from "./screens";

/** Titled placeholder for a UX-01 screen that is not built yet, or not built for 1 Oct. */
export function ScreenPlaceholder({ screen }: { screen: ScreenDef }) {
  const params = useParams();

  useEffect(() => {
    document.title = `${screen.title} · Giraffe`;
  }, [screen.title]);

  const routeParams = Object.entries(params).filter((entry): entry is [string, string] => entry[1] !== undefined && entry[0] !== "*");
  const headingId = `${screen.id}-${screen.path.replace(/[^a-z]/gi, "")}-status`;
  const postGoLive = screen.tag === "Post-go-live";

  return (
    <>
      <div className="gf-pagehead">
        <h1>{screen.title}</h1>
        <p className="sub">
          {screen.id} · {screen.tag} · stream {screen.stream} · UX-01 §6
        </p>
      </div>

      <section className="gf-section" aria-labelledby={headingId}>
        <div className="sechd">
          <h2 id={headingId}>{postGoLive ? "Not part of the 1 Oct release" : "Not built yet"}</h2>
          <span className="secs">placeholder route</span>
        </div>
        <div className="pad stack">
          <p>{screen.note ?? `This route exists so navigation and parallel work can start. The screen is specified in UX-01 ${screen.id}.`}</p>
          {routeParams.length > 0 && (
            <p>
              Route parameters:{" "}
              {routeParams.map(([name, value]) => (
                <code key={name} className="gf-code">
                  {name}={value}
                </code>
              ))}
            </p>
          )}
        </div>
      </section>
    </>
  );
}
